import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactNode } from 'react';

import { locator } from '../../testing/e2e-locator/locator';

/**
 * Custom CheckBoxOutlineBlank icon that uses MUI's CheckBoxOutlineBlankIcon design.
 * Cropped viewBox from "0 0 24 24" to "3 3 18 18" to remove all padding and make path fill 24x24px
 * See: https://mui.com/material-ui/material-icons/?query=checkbox&selected=CheckBoxOutlineBlank
 */
export const CheckBoxOutlineBlankIcon = (props: SvgIconProps): ReactNode => (
  <SvgIcon
    {...props}
    data-testid={locator.components.checkboxOutlineBlankIcon.root}
    viewBox="3 3 18 18"
  >
    <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
  </SvgIcon>
);
